module.exports = __webpack_public_path__ + "img/7.b2d1dc53.png";